import type { SVGProps } from 'react'

export const LegalScale = (props: SVGProps<SVGSVGElement>) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.696 21.965C35.9246 22.3355 36.0331 22.7677 36.0066 23.2023C35.8114 26.7762 32.9201 29.6098 29.343 29.733C25.7637 29.613 22.8692 26.7783 22.6746 23.2023C22.6455 22.7638 22.7528 22.3271 22.9819 21.9521L29.3366 11.1973C29.3366 11.1973 34.3419 19.6808 35.696 21.965Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.9427 22.5347H22.7324"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.021 27.4337C17.2482 27.8064 17.3544 28.2403 17.3252 28.6758C17.1323 32.2501 14.2406 35.0848 10.6632 35.2065C7.08443 35.0875 4.18947 32.2544 3.99321 28.679C3.96714 28.2386 4.07905 27.8011 4.31334 27.4273L10.668 16.666L17.021 27.4337Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.2677 28.0035H4.05737"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.3367 11.1973L10.6633 16.6667"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6665 7.99609V14.3235"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
